// extracted by mini-css-extract-plugin
export default {"quantity_container":"SH","hiddenflavorstring":"TH","loadingLine":"UH","productimgwrap":"VH","productimg":"WH","circlepic":"XH","productinfo":"YH","grey_x":"ZH","cartrow":"aI","bold":"bI","title":"cI","blue":"eI","strike":"fI","flexgap":"gI","flavorstring":"hI","nodecorate":"iI","flavorstring_link":"jI","rdstring":"kI","removeditemblock":"lI","removed_heading":"mI","removed_text":"nI","addback":"oI"};
    if(module.hot) {
      // 1730991508614
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  